import { NoInfer } from 'react-redux';

import { ActionReducerMapBuilder, Draft, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { RootState } from 'store/rootReducer';
import { PendingActionType, RejectedActionType, errorOr, fulfilled, pending, rejected } from 'store/storeHelpers';

import { ModelError, State } from 'models';
import { AktivitetPagaendeIndex } from 'models/apiModels/AktivitetPagaendeIndex';

import BebyggelseApi from 'api/bebyggelseApi';

const requestCondition = (getState: () => unknown) => {
  const { utforarePagaendeAktiviteter } = getState() as RootState;
  if (utforarePagaendeAktiviteter.requestStatus === 'pending') return false;
};

export const getPagaendeAktiviteter = createAsyncThunk<
  Array<AktivitetPagaendeIndex>,
  string,
  { rejectValue: ModelError }
>(
  'get/utforare/pagaende/aktiviteter',
  async (organisationsnummer: string, { rejectWithValue }): Promise<any> => {
    const response: Response =
      await BebyggelseApi.utforare.getPagaendeAktiviteterByOrganisationsnummer(organisationsnummer);
    return errorOr(response, rejectWithValue);
  },
  {
    condition: (organisationsnummer: string, { getState }) => requestCondition(getState)
  }
);

const initialState: State<AktivitetPagaendeIndex[]> = {
  requestStatus: 'idle',
  requestType: undefined,
  currentRequestId: undefined,
  data: [],
  error: undefined
};

const utforarePagaendeAktiviteterSlice = createSlice({
  name: 'utforarePagaendeAktiviteterSlice',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<State<Array<AktivitetPagaendeIndex>>>>) => {
    builder.addCase(
      getPagaendeAktiviteter.pending,
      (state: Draft<State<Array<AktivitetPagaendeIndex>>>, action: PendingActionType): void => pending(state, action)
    );
    builder.addCase(
      getPagaendeAktiviteter.fulfilled,
      (state: Draft<State<Array<AktivitetPagaendeIndex>>>, action): void => fulfilled(state, action)
    );
    builder.addCase(
      getPagaendeAktiviteter.rejected,
      (state: Draft<State<Array<AktivitetPagaendeIndex>>>, action: RejectedActionType): void => rejected(state, action)
    );
  }
});

export default utforarePagaendeAktiviteterSlice.reducer;
